import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {UserDisplayPermissionModel} from '../models/user-display-permission.model';
import {UserModel} from '../../customer/customer-shared/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
    endpointUrl = `${environment.apiUrl}/user`;

    constructor(private http: HttpClient) {
    }

    getUserDisplayPermissions(userId: number): Observable<UserDisplayPermissionModel> {
        return this.http.get<UserDisplayPermissionModel>(`${this.endpointUrl}/userdisplaypermission/${userId}`);
    }

    updateUDP(udp: UserDisplayPermissionModel): Observable<any> {
        return this.http.put(`${this.endpointUrl}/userdisplaypermission`, udp);
    }

    getUser(userId: number): Observable<UserModel> {
        return this.http.get<UserModel>(`${this.endpointUrl}/${userId}`);
    }
}
